<template>
    <section class="component" style="position: relative">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.room-map-settings.rooms-plans')}}
            </span>
            <section class="component__header__action">
                <button class="component__button component__button--small component__button--white" @click="$store.commit('roomMap/setIsShowAddRoomMapStatus', true)">
                    <img src="@/assets/icons/components/plus-small.svg" style="filter: invert(1);"/>
                    <span class="component__button__text">{{$t('com.global.add')}}</span>
                </button>
            </section>
        </section>
        <section class="component__body placeholders">
            <section v-if="isAnyRoomMaps">
                <table class="table-bootstrap table-bootstrap-hover table-bootstrap-bordered table-bootstrap-striped align-middle">
                    <thead>
                        <tr>
                            <th>{{$t('com.file.edit-announcement.name')}}</th>
                            <th>{{$t('com.file.logs.add-date')}}</th>
                            <th style="width: 20px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in availableRoomMaps" :key="index">
                            <td>{{ item.name }}</td>
                            <td>{{ humanDate(item.createdDate) }}</td>
                            <td>
                                <ButtonGroup>
                                    <ButtonOutline color="light" type="sm" @click="openRoomMap(item)">
                                        <ButtonIcon icon="edit" />
                                        {{$t('com.global.edit')}}
                                    </ButtonOutline>
                                    <ButtonOutline color="light" type="sm" @click="editRoomMap(item)" v-if="item.id > 0">
                                        <ButtonIcon icon="edit" />
                                        {{$t('com.file.contact-box.settings')}}
                                    </ButtonOutline>
                                    <ButtonOutline color="danger" type="sm" @click="deleteRoomMap(item)" v-if="item.id > 0">
                                        <ButtonIcon icon="delete" />
                                        {{$t('com.global.delete')}}
                                    </ButtonOutline>
                                </ButtonGroup>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <section class="info2">
                    {{$t('com.file.room-map-settings.info')}}
                </section>
            </section>
            <section class="text-center" v-else>
                {{$t('com.file.placeholder-settings.no-boards')}}
            </section>
        </section>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
    import SmallLoader from "../../../../BasicControls/SmallLoader.vue";
    import RoomMapService from "@/services/room.map.service";
    import { encryptStorage } from '@/services/encrypt.service';
    import moment from "moment";

    export default {
        name: "RoomMapSettings",
        components: {
            SmallLoader,
        },
        data(){
            return {
                isLoading: false,
                roomMapModule: encryptStorage.getItem('modules').ps,
            }
        },
        computed: {
            availableRoomMaps(){
                return this.$store.state.roomMap.roomMaps;
            },
            isAnyRoomMaps(){
                let roomMaps = this.availableRoomMaps;
                return (roomMaps !== undefined && roomMaps !== null && roomMaps.length > 0)
            }
        },
        async mounted(){
            try {
                if (this.isRoomMapModule() === false)
                    return;

                this.isLoading = true;
                await RoomMapService.GetAll();
            }
            catch(e){
                console.log(e);
            }
            finally{
                this.isLoading = false;
            }
        },
        methods: {
            isRoomMapModule() {
                if (this.roomMapModule === 1)
                    return true;

                return false;
            },
            async deleteRoomMap(item) {
                const actionToFire = async () => {
                    try {
                        if (item.id === 0)
                            return;

                        this.isLoading = true;
                        await RoomMapService.Delete(item.id);
                    }
                    finally {
                        this.isLoading = false;
                    }
                }
                this.$store.commit("setAlertData", this.createAlertData());
                this.$store.commit("showConfirmationAlertWithData", actionToFire);
            },
            alertInfo() {
                var info = '';

                info += "<p>" + this.$t('com.global.confirmation-alert') + "</p>";
                info += "<p>" + this.$t('com.file.room-map-settings.confirmation-alert') + "</p>";

                return info;
            },
            createAlertData() {
                var alertData = {
                    mainText: this.alertInfo(),
                    buttons: [
                        {
                            id: 1,
                            text: this.$t('com.global.yes'),
                            color: '#d80418'
                        }]
                };

                return alertData;
            },
            editRoomMap(item) {
                if (item.id === 0)
                    return;

                this.$store.commit('roomMap/setSelectedRoomMap', item)
                this.$store.commit('roomMap/setIsShowAddRoomMapStatus', true)
            },
            openRoomMap(item) {
                const routeData = this.$router.resolve({
                    name: 'RoomMap',
                    params: {
                        sessionid: 0,
                        roomMapId: item.id
                    }
                });

                const width = Math.floor(window.innerWidth * 0.99);
                const height = Math.floor(window.innerHeight * 0.99);

                window.open(
                    routeData?.href,
                    'name',
                    `width=${width},height=${height}`
                );
            },
            humanDate(date) {
                if (date === null || date === undefined)
                    return "-";

                return moment(date).format("DD MMMM YYYY HH:mm");
            }
        }
    }
</script>
<style lang="scss">
    @use "@/assets/scss/user-profile-component.scss";

    .info2 {
        text-wrap: wrap;
        max-width: 800px;
        font-size: 12px;
        padding: 10px;
    }

</style>